import React from "react";
import { isNil } from "ramda";

import { Range } from "affinityUI/data/valueDisplay";

type UnitDisplayProps = { normalRange?: RangeValue };

export const UnitWBC: React.FC<UnitDisplayProps> = ({ normalRange }) => (
  <>{!isNil(normalRange) && <Range value={normalRange} />} (10⁹/L)</>
);

export const UnitNeutrophil: React.FC<UnitDisplayProps> = ({ normalRange }) => (
  <>{!isNil(normalRange) && <Range value={normalRange} />} (10⁹/L)</>
);

export const UnitHaemoglobin: React.FC<UnitDisplayProps> = ({ normalRange }) => (
  <>{!isNil(normalRange) && <Range value={normalRange} />} (g/L)</>
);

export const UnitPlatelet: React.FC<UnitDisplayProps> = ({ normalRange }) => (
  <>{!isNil(normalRange) && <Range value={normalRange} />} (10⁹/L)</>
);
